/********************************************* ASSETS *********************************************/
const s = {
    ...require(`../auth-landing-root.scss`),
    ...require(`./info-panel.scss`),
};

const canimmunizeWhiteLogo = require(`./canimmunize-logo-white.png`);

/********************************************* IMPORT *********************************************/
import React from 'react';
import cn from 'classnames';
import {translate} from '@canimmunize/core-imports';

/**************************************** TYPE DEFINITIONS ****************************************/
interface InfoPanelProps {}

/********************************************* EXPORT *********************************************/
/**
 * @export InfoPanel
 */
export const InfoPanel = (props?: InfoPanelProps) => {
    return (
        <div className={cn(s[`info-panel`])}>
            <img src={canimmunizeWhiteLogo} className={cn(s[`canimmunize-logo-white`], `mw-100`)} />
            <h1 className={cn(s[`text-block`])}>
                {translate(`canimmunize_webclient_front_page_description`)}
            </h1>
            <span className={cn(`mr-5`)}>
                <a href={translate(`social_link_ios`)} className={cn(`purple-wide-focus-outline`)}>
                    <img
                        src={translate(`images_download_from_apple`)}
                        className={cn(s[`download-app`])}
                    />
                </a>
            </span>
            <span className={cn(`ml-5`)}>
                <a
                    href={translate(`social_link_android`)}
                    className={cn(`purple-wide-focus-outline`)}
                >
                    <img
                        src={translate(`images_download_from_google`)}
                        className={cn(s[`download-app`])}
                    />
                </a>
            </span>
        </div>
    );
};
